
































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Tips extends Vue {
    @Prop({required: true})
    text!: string

    @Prop()
    link: string | undefined

    showToolTip = false


    get helpText() {
        return this.text
    }

    get linkText() {
        if (!this.link) return ""
        return this.link
    }

    openToolTip(event: MouseEvent) {
        this.showToolTip = true
    }

    closeToolTip(event: MouseEvent) {
        this.showToolTip = false
    }
}
